import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { findDOMNode } from 'react-dom';
import { connect, Dispatch } from 'react-redux';

import GridDayContent, { GridDayProps } from '../views/grid-day';
import GridDayEmpty, { GridDayEmptyProps } from '../views/grid-day-empty';
import { ICalendarReduxState } from "../classes/index";
import { RawActions } from "@adage/ace-calendar";
import { isElementVisible } from "../helpers/index";

interface LoaderExternalProps {

}

interface StateToProps {
    endDate: moment.Moment;
    startDate: moment.Moment;
    lastMonthToDisplay: moment.Moment;
    updating: boolean;
}

interface DispatchToProps {
    goToMonth: (month: moment.Moment) => any;
    setMonths: (startDate: moment.Moment, endDate: moment.Moment) => any;
}

type LoaderProps = LoaderExternalProps & StateToProps & DispatchToProps;

class Loader extends React.Component<LoaderProps, null> {
    componentDidMount() {
        window.addEventListener("scroll", this.onBoundScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onBoundScroll);
    }

    componentWillReceiveProps(props: LoaderProps) {
        // Use this.props or else it'll keep loading future months each time there's an update.
        const element = findDOMNode(this);
        const noMoreMonths = this.props.endDate.isAfter(this.props.lastMonthToDisplay);
        if (!this.props.updating && isElementVisible(element) && !noMoreMonths) {
            this.props.setMonths(this.props.startDate, this.props.endDate.clone().add(1, "month").endOf("month"));
        }
    }

    private onBoundScroll = _.debounce(this.onScroll.bind(this), 500, {
        leading: true,
        trailing: false
    });

    private onScroll() {
        const element = findDOMNode(this);
        const noMoreMonths = this.props.endDate.isAfter(this.props.lastMonthToDisplay);
        if (isElementVisible(element) && !noMoreMonths) {
            this.props.setMonths(this.props.startDate, this.props.endDate.clone().add(1, "month").endOf("month"));
        }
    }

    render() {
        return (
            <div className="loader-container">
                <div className="loader">Loading&hellip;</div>
            </div>
        );
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: LoaderExternalProps) {
    return {
        endDate: state.calendarModel.endDate,
        startDate: state.calendarModel.startDate,
        lastMonthToDisplay: state.calendarModeModel.lastDateToLoad,
        updating: state.calendarModel.updating
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>): DispatchToProps {
    return {
        goToMonth: (month: moment.Moment) => dispatch(RawActions.goToMonth(month)),
        setMonths: (startDate: moment.Moment, endDate: moment.Moment) => dispatch(RawActions.setDates(startDate, endDate))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(Loader);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/loader.tsx